import React, { useEffect, useState } from "react";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { useNavigate } from "react-router-dom";
import { GetOptions, GetPermissions } from "../components/Options";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import LandingPage from "./LandingPage";
import RealTimeTrend from "./trend/RealTimeTrend";
import WeeklyTrend from "./trend/WeeklyTrend";
import MonthlyTrend from "./trend/MonthlyTrend";
import YearlyTrend from "./trend/YearlyTrend";
import FinYearlyTrend from "./trend/FinYearlyTrend";
import PerformanceTrend from "./trend/PerformanceTrend";
import InventoryTrend from "./trend/InventoryTrend";
import "./Dashboard.scss";

const DASHBOARD_TABS = [
    { title: "Real Time Data", permission: "ViewBasicDashboard", component: RealTimeTrend, description: "Today's activity, transactions and weighbridge performance." },
    { title: "Weekly Trends", permission: "ViewAdvancedDashboard", component: WeeklyTrend, description: "Overview of key metrics and performance for the current week." },
    { title: "Monthly Trends", permission: "ViewAdvancedDashboard", component: MonthlyTrend, description: "Overview of key metrics and performance for the current month." },
    { title: "Yearly Trends", permission: "ViewAdvancedDashboard", component: YearlyTrend, description: "Track your annual activity and compare performance over time." },
    { title: "Financial Year", permission: "ViewAdvancedDashboard", component: FinYearlyTrend, description: "Key metrics and performance for the financial year to date." },
    { title: "Performance", permission: "ViewCustomDashboard", component: PerformanceTrend, description: "Explore performance by site, product, customer and job." },
    { title: "Inventory", permission: "ViewInventoryDashboard", component: InventoryTrend, description: "Monitor stock levels, product movements and this year versus last year inventory comparison." },
];
const REQUIRED_PERMISSIONS = [...new Set(DASHBOARD_TABS.map((tab) => tab.permission))];

const Dashboard = () => {
    const [selected, setSelected] = useState(0);
    const [permissions, setPermissions] = useState(null);
    const [sites, setSites] = useState([]);
    const [siteId, setSiteId] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem("userid") === null) {
            navigate("/logout");
            return;
        }
        GetPermissions(REQUIRED_PERMISSIONS, setPermissions);
        let active = true;
        GetOptions(options => {
            if (active) setSites((options.sites || []).filter(site => Number(site.id) > 1));
        }).catch(() => {});
        return () => { active = false; };
    }, [navigate]);

    if (!permissions) return <div className="wm-dashboard" role="status">Loading dashboard…</div>;
    const tabs = DASHBOARD_TABS.filter((tab) => permissions[tab.permission]);
    if (!tabs.length) return <LandingPage />;

    return (
        <main className="wm-dashboard">
            <TabStrip id="Dashboard" selected={selected} onSelect={(event) => setSelected(event.selected)}>
                {tabs.map(({ title, description, component: Content }) => (
                    <TabStripTab key={title} title={title}>
                        <div className="wm-dashboard__heading">
                            <div><h1>{title}</h1><p>{description}</p></div>
                            {sites.length > 1 && !["Performance", "Inventory"].includes(title) ? (
                                <label className="wm-dashboard__site">Site
                                    <DropDownList ariaLabel="Dashboard site" data={[{ id: 0, name: "All" }, ...sites]}
                                        textField="name" dataItemKey="id"
                                        value={sites.find(site => Number(site.id) === siteId) || { id: 0, name: "All" }}
                                        onChange={event => setSiteId(Number(event.value.id))} />
                                </label>
                            ) : <span className="wm-dashboard__tagline">WEIGH TODAY<br />FOR A BRIGHTER TOMORROW</span>}
                        </div>
                        <Content key={!["Performance", "Inventory"].includes(title) ? siteId : title} siteId={siteId} />
                    </TabStripTab>
                ))}
            </TabStrip>
        </main>
    );
};

export default Dashboard;
